import React from "react";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import { Field } from "formik";
import Checkbox from "@material-ui/core/Checkbox";
import DOMPurify from "dompurify";

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  max-height: 75px;
  overflow-y: auto;
`;

const StyledCheckBox = styled(Checkbox)``;

const Text = styled(Typography).attrs({
  variant: "subtitle2",
  color: "textSecondary",
})`
  flex-grow: 1;
  && {
    margin-top: 10px;
  }
`;

const checkboxRegex = /{checkbox}/gi;

export const isOptInDisclaimer = (text) => checkboxRegex.test(text);

const FormikCheckbox = ({ field, ...props }) => {
  const { name, value, onChange } = field;
  return (
    <StyledCheckBox
      id="disclaimer-checkbox"
      name={name}
      checked={value}
      onChange={onChange}
      inputProps={{
        "aria-label": "disclaimer checkbox",
      }}
      {...props}
    />
  );
};

const DisclaimerField = ({ name, children }) => {
  const textComponents = [];
  const split = children.split(checkboxRegex);
  for (let idx = 0; idx < split.length; idx++) {
    const text = split[idx];
    if (text !== "") {
      textComponents.push(
        <Text
          key={idx}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(text),
          }}
        ></Text>
      );
    }
    if (idx !== split.length - 1) {
      textComponents.push(
        <Field component={FormikCheckbox} name={name} key={`${idx}-checkbox`} />
      );
    }
  }
  return <Wrapper>{textComponents}</Wrapper>;
};

export default DisclaimerField;
